import React from 'react'
import { ReactComponent as CashIcon } from './cash-hand.svg'
import { ReactComponent as MoneyBagIcon } from './money-bag.svg'
import { ReactComponent as LevKvantKgIcon } from './lev-kvant-kg.svg'
import { ReactComponent as ShippingCostIcon } from './shipping-cost.svg'

import { ReactComponent as WasteIcon } from './waste.svg'
import { ReactComponent as WaterContentIcon } from './water-content.svg'
import { ReactComponent as OilContentIcon } from './oil-content.svg'
import { ReactComponent as AnalysisCostIcon } from './analysis-cost.svg'
import { ReactComponent as UnitPriceIcon } from './unit-price.svg'
import { ReactComponent as ProteinIcon } from './protein.svg'

import { ReactComponent as DensityDeductionIcon } from './density-deduction.svg'
import { ReactComponent as DensityIcon } from './density.svg'
import { ReactComponent as OatColorIcon } from './oat-color.svg'
import { ReactComponent as PartWholeGrainIcon } from './part-whole-grain.svg'
import { ReactComponent as ResearchCostIcon } from './research-cost.svg'
import { ReactComponent as UnitPriceReducedIcon } from './unit-price-reduced.svg'
import { ReactComponent as DonIcon } from './don.svg'
import { ReactComponent as WholeGrainIcon } from './whole-grain.svg'

export const Icon = ({ iconName }: { iconName: string }) => {
  const iconMap = {
    cash: <CashIcon />,
    moneyBag: <MoneyBagIcon />,
    levKvantKg: <LevKvantKgIcon />,
    shippingCost: <ShippingCostIcon />,
    waste: <WasteIcon />,
    waterContent: <WaterContentIcon />,
    oilContent: <OilContentIcon />,
    analysisCost: <AnalysisCostIcon />,
    unitPrice: <UnitPriceIcon />,
    protein: <ProteinIcon />,
    densityDeduction: <DensityDeductionIcon />,
    densityIcon: <DensityIcon />,
    oatColor: <OatColorIcon />,
    partWholeGrain: <PartWholeGrainIcon />,
    researchCost: <ResearchCostIcon />,
    unitPriceReduced: <UnitPriceReducedIcon />,
    don: <DonIcon />,
    wholeGrain: <WholeGrainIcon />,
  }

  return iconMap[iconName] ?? null
}
